import { SearchMode } from './SearchMode.enum';
export interface IColumn {
    name: string;
    type?:
        | 'text'
        | 'date'
        | 'button'
        | 'translated-text'
        | 'truncated-text'
        | 'status'
        | 'progress'
        | 'text-with-ellipsis'
        | 'img'
        | 'array'
        | 'active';
    property?: string;
    action?: string;
    flex?: number;
    excludedFromSearch?: boolean;
    searchMode?: SearchMode;
    hideColumnName?: boolean;
}
